<template>
  <label>{{ label }}</label>
  <VueMultiselect ref="multiselect" v-model="value" :options="dictionaryEndpointData" :close-on-select="true" :clear-on-select="true"
    :placeholder="placeholder" :max-height="600" :id="id" :aria-label="label" :endpoint="endpoint" :execsearch="execsearch"
    :endpointval="endpointval" :storeendpointval="storeendpointval" :noresults="noresults" :preserve-search="true"
    :allowEmpty="false" :taggable="true" label="name" track-by="name" @search-change="handleSearchChange">
    <template #noOptions>{{ noresults }}</template>
    <template #noResult>{{ noresults }}</template>
  </VueMultiselect>
</template>

<script>
import axios from "axios";
import VueMultiselect from "vue-multiselect";
// we are using this, just the @next version for vue 3
// https://vue-multiselect.js.org/
export default {
  components: {
    VueMultiselect,
  },
  props: {
    id: String,
    options: Array,
    label: String,
    endpoint: String,
    endpointval: String,
    storeendpointval: String,
    noresults: String,
    populate: Boolean,
    execsearch: {
      type: String,
      default: "0",
    },
  },
  emits: ["change"],
  data(instance) {
    return {
      value: "",

      dictionaryEndpointData: [],
      dictionaryEndpointDataLoading: false,
      dictionaryEndpointDataError: null,

      placeholder: instance.store[instance.store.currentCulture].dictionary.placeholderPickOrSearch,
    };
  },
  methods: {
    reset() {
      this.value = null;
    },
    setInputAriaLabel() {
      const input = this.$refs.multiselect?.$refs?.search;
      if (input) input.setAttribute('aria-label', this.placeholder);
    },
    async GetEndpointData(searchQuery) {
      this.dictionaryEndpointDataLoading = true;
      this.dictionaryWorkAreasError = null;

      try {
        const endpointData = await axios.get(`${this.endpoint}${searchQuery}`);

        this.dictionaryEndpointData = endpointData.data;
        this.dictionaryEndpointData.unshift({ name: searchQuery });

      } catch (error) {
        this.dictionaryEndpointDataError = "Der opstod en fejl under hentning af data:" + error.message;
      } finally {
        this.dictionaryEndpointDataLoading = false;
      }
    },
    async handleSearchChange(searchQuery) {
      if (searchQuery.length >= this.execsearch) this.GetEndpointData(searchQuery);
    },
  },
  watch: {
    value() {
      this.$emit("change", { selectedValue: this.value, storeendpointval: this.storeendpointval, endpointValue: this.value[this.endpointval] });
    },
    placeholder() {
      this.setInputAriaLabel();
    },
  },
  mounted() {
    if (this.populate) this.GetEndpointData("");

    this.setInputAriaLabel();

    this.emitter.on("culture-change", () => {
      this.placeholder = this.store[this.store.currentCulture].dictionary.placeholderPickOrSearch;
    });
  },
};
</script>
